const itemDisplayMap = {
  peak_consumption: { displayName: 'Consumo Ponta', unit: 'KWh' },
  off_peak_consumption: { displayName: 'Consumo Fora Ponta', unit: 'KWh' },
  off_peak_injected_energy_gdi: { displayName: 'Energia Injetada Fora Ponta', unit: 'KWh' },
  yellow_flag_fee: { displayName: 'Bandeira Amarela', unit: 'R$' },
  measured_peak_demand: { displayName: 'Demanda Ponta', unit: 'KW' },
  measured_off_peak_demand: { displayName: 'Demanda Fora Ponta', unit: 'KW' },
  contracted_peak_demand: { displayName: 'Demanda Contratada Ponta', unit: 'KW' },
  contracted_off_peak_demand: { displayName: 'Demanda Contratada Fora Ponta', unit: 'KW' },
  peak_reactive: { displayName: 'Reativo Ponta', unit: '' },
  off_peak_reactive: { displayName: 'Reativo Fora Ponta', unit: '' },
  unused_peak_demand: { displayName: 'Dem N Utilizada Ponta', unit: '' },
  unused_off_peak_demand: { displayName: 'Dem N Utilizada Fora Ponta', unit: '' },
  exceeded_peak_demand: { displayName: 'Ultrapassagem Ponta', unit: '' },
  exceeded_off_peak_demand: { displayName: 'Ultrapassagem Fora Ponta', unit: '' },
  exceeded_reactive_peak_demand: { displayName: 'Demanda Reat Exced. Ponta', unit: '' },
  exceeded_reactive_off_peak_demand: { displayName: 'Demanda Reat Exced. Fora Ponta', unit: '' },
  public_light_bill: { displayName: 'Conta de Luz Pública', unit: 'R$' },
  tudsg_demand: { displayName: 'Demanda Contratada TUSDG', unit: 'KW' },
  credit_value: { displayName: 'Crédito', unit: 'R$' },
  debit_value: { displayName: 'Débito', unit: 'R$' },
  relative_emission: { displayName: 'Emissão Relativa', unit: '' },
  covid_bill: { displayName: 'Conta Covid', unit: 'KW' },
  hydrical_scarcity_covid_bill: { displayName: 'Conta Covid Escassez Hídrica', unit: 'KW' },
  late_fee: { displayName: 'Multa por Atraso', unit: 'R$' },
  bill_fine: { displayName: 'Juros', unit: 'R$' },
  monetary_adjustment: { displayName: 'Ajuste Monetário', unit: 'R$' },
  'injected_atv_energy_gdi_ouc_1/2026_mpt': { displayName: 'Energia Atv Injetada', unit: 'KWh' },
}

export const getDisplayInfo = (key: string) => {
  const match = key.match(/_\((\d+)\)$/)
  const suffix = match ? ` (${match[1]})` : ''
  const cleanKey = key.replace(/_\(\d+\)$/, '')

  if (cleanKey in itemDisplayMap) {
    const item = itemDisplayMap[cleanKey]
    return {
      displayName: item.displayName + suffix,
      unit: item.unit,
    }
  }

  return {
    displayName: key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '),
    unit: '',
  }
}

export const isValueWithinErrorMargin = (calculatedValue: number, apiValue: number): boolean => {
  const errorMargin = Math.abs(apiValue) * 0.01
  return Math.abs(calculatedValue - apiValue) <= errorMargin
}

// Badge de status no histórico de faturas: fatura cheia (verde) vs registro
// parcial vindo do backfill da página 2 (âmbar).
export const getInvoiceStatusBadge = (complete: boolean): { label: string; classes: string } => {
  return complete
    ? { label: 'Completa', classes: 'bg-green-100 text-green-700' }
    : { label: 'Parcial', classes: 'bg-amber-100 text-amber-700' }
}
